export default "/_next/static/chunks/fonts/HK Grotesk Black-2a57aca5339c4d5fda8391a81c14a16d.otf";